var AdminPage, EditGalleryPage, ExportGalleryPage, GalleryPhotoPage, GalleryThumbsPage, HomePage, LoginPage;

HomePage = require('./pages/HomePage');

GalleryThumbsPage = require('./pages/GalleryThumbsPage');

GalleryPhotoPage = require('./pages/GalleryPhotoPage');

LoginPage = require('./pages/LoginPage');

AdminPage = require('./pages/AdminPage');

EditGalleryPage = require('./pages/EditGalleryPage');

ExportGalleryPage = require('./pages/ExportGalleryPage');

module.exports = {
  defaultRoute: '/home',
  generate: function(store) {
    return {
      '/home': HomePage(store),
      '/login': LoginPage(store),
      '/gallery/:galleryId/thumbs': GalleryThumbsPage(store),
      '/gallery/:galleryId/photos/:photoName': GalleryPhotoPage(store),
      '/admin': AdminPage(store),
      '/admin/editGallery': EditGalleryPage(store),
      '/admin/exportGallery': ExportGalleryPage(store)
    };
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvUm91dGVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3VpL1JvdXRlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxRQUFBLEdBQWMsT0FBQSxDQUFRLGtCQUFSOztBQUNkLGlCQUFBLEdBQXFCLE9BQUEsQ0FBUSwyQkFBUjs7QUFDckIsZ0JBQUEsR0FBb0IsT0FBQSxDQUFRLDBCQUFSOztBQUNwQixTQUFBLEdBQWUsT0FBQSxDQUFRLG1CQUFSOztBQUNmLFNBQUEsR0FBZSxPQUFBLENBQVEsbUJBQVI7O0FBQ2YsZUFBQSxHQUFtQixPQUFBLENBQVEseUJBQVI7O0FBQ25CLGlCQUFBLEdBQW9CLE9BQUEsQ0FBUSwyQkFBUjs7QUFFcEIsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsWUFBQSxFQUFjLE9BREU7RUFFaEIsUUFBQSxFQUFVLFNBQUMsS0FBRDtXQUFXO01BQ3BCLE9BQUEsRUFBUyxRQUFBLENBQVMsS0FBVCxDQURXO01BRXBCLFFBQUEsRUFBVSxTQUFBLENBQVUsS0FBVixDQUZVO01BR3BCLDRCQUFBLEVBQThCLGlCQUFBLENBQWtCLEtBQWxCLENBSFY7TUFJcEIsdUNBQUEsRUFBeUMsZ0JBQUEsQ0FBaUIsS0FBakIsQ0FKckI7TUFLcEIsUUFBQSxFQUFVLFNBQUEsQ0FBVSxLQUFWLENBTFU7TUFNcEIsb0JBQUEsRUFBc0IsZUFBQSxDQUFnQixLQUFoQixDQU5GO01BT3BCLHNCQUFBLEVBQXdCLGlCQUFBLENBQWtCLEtBQWxCLENBUEo7O0VBQVgsQ0FGTSJ9
